// extracted by mini-css-extract-plugin
export default {"projectsTable":"styles_projectsTable__klqyv","ant-table-cell":"styles_ant-table-cell__Nxooh","projectClosedStatus":"styles_projectClosedStatus__puOb8"};